import React from "react"
import {
  Card,
} from 'AtomicComponents'
import urlHandler from 'AtomicUtils/urlHandler'

class AccessoryItem extends React.Component {

  _handleClick = () => {
    const {partNumber,  isPack} = this.props
    const href = `${isPack ? "/accessory-pack/" : "/accessory/"}${encodeURIComponent(partNumber)}`
    new urlHandler(href).redirect()
  }

  render() {

    const {
      name,
      imageUrl,
      priceText,
      grades,
      gtm
    } = this.props


    return (
      <Card
        heading={name}
        imageSrc={imageUrl}
        description={priceText}
        onClick={this._handleClick}
        linkText={'READ MORE +'}
        disclaimer={grades && grades.length && `Only available on ${grades.join(", ")} models`}
        gtm={gtm}
      />
    )
  }
}

export default AccessoryItem



// WEBPACK FOOTER //
// ./src/AtomicContainers/AccessoryItem/AccessoryItem.jsx